<template>
  <van-dialog
    v-model="show"
    class="dialog"
    show-cancel-button
    @cancel="confirm(true)"
    @confirm="confirm(false)"
  >
    <van-form style="position: relative; margin-top: 1rem; display: flex">
      <van-field v-model="formData.name" name="name" label="仓库名称" />
      <van-button type="primary" @click="search">查询</van-button>
    </van-form>
    <van-list
      class="scrollList"
      :finished="true"
      :loading-text="'加载中...'"
      :finished-text="'已显示全部'"
      @load="getProductList"
      :error="true"
      :error-click="getProductList"
    >
      <van-cell
        ref="cell"
        v-for="item in storeList"
        :key="item.id"
        :title="item.name"
        @click="showActive(item)"
      />
    </van-list>
  </van-dialog>
</template>
<script>
import { AVAILABLE } from "../utils/constants";
import { reqSc } from "../service/api/product";
export default {
  name: "storeSelect",
  components: {},
  props: {
    visible: false,
  },
  data() {
    return {
      show: false,
      currentRow: {},
      data: [],
      storeList: [],
      formData: { name: "", available: true },
      columns: [
        {
          label: "编号",
          prop: "id",
        },
        {
          label: "名称",
          prop: "name",
        },
        {
          label: "状态",
          prop: "available",
        },
      ],
      statusList: AVAILABLE,
    };
  },
  watch: {
    visible(newVal, oldVal) {
      this.show = newVal;
    },
  },
  created() {
    this.getProductList();
  },
  methods: {
    search() {
      this.storeList = this.data.filter((el) => {
        return this.formData.name.includes(el.name);
      });
    },
    showActive(item) {
      this.currentRow = item;
      const exitIndex = this.storeList.findIndex((i) => i.id === item.id);
      this.$refs.cell.forEach((el, index) => {
        el.classList.remove("active");
        if (index == exitIndex) {
          el.classList.add("active");
        }
      });
    },
    confirm(closeFlag) {
      console.log(this.currentRow);
      if (closeFlag) this.$emit("confirm", {});
      else this.$emit("confirm", this.currentRow);
      this.show = false;
      this.currentRow = {};
    },
    getProductList() {
      reqSc(this.formData).then((res) => {
        this.data = res.data.datas;
        this.storeList = res.data.datas;
      });
    },
  },
};
</script>
<style lang="less" scoped>
.active {
  background: #15b2c7;
}
.dialog {
  height: 85%;
}

::v-deep .van-dialog__content {
  height: 100%;
}

.scrollList {
  height: calc(100% - 115px) !important;

  overflow: auto;
}
::v-deep .van-dialog__footer {
  position: sticky;
  bottom: 0;
}
::v-deep .van-cell {
  padding: 2px 10px !important;
}
</style>
